import React, { useContext } from 'react';
import { ContainerContent, RowHead } from '@firsttable/web-components/molecules';
import { TrackProvider } from '@/components/analytics/context/AnalyticsContext';
import SilverstripeContext from '@/components/context/Silverstripe';
import HubSpotSuggestRestaurantForm from '@/components/atoms/HubSpotSuggestRestaurantForm';
import SEO from '@/components/SEO';

const SuggestRestaurantPage = () => {
  const { page } = useContext(SilverstripeContext);

  return (
    <TrackProvider pageEventName="marketing_page_viewed" source_page="suggest_restaurant">
      <SEO
        title={page.metaTitleFormatted}
        id={page.id}
        description={page.metaDescription}
        ogImage={page.ogImage}
        metaTags={page.metaTags}
        slug={page.slug}
      />
      <ContainerContent>
        <RowHead title={page.title} subTitle={page.subTitle} mb={0} />
        <div className="flex w-full justify-center">
          <div className="w-full max-w-screen-sm">
            <HubSpotSuggestRestaurantForm />
          </div>
        </div>
      </ContainerContent>
    </TrackProvider>
  );
};

export default SuggestRestaurantPage;
